import * as Sentry from '@sentry/react'
import Clarity from '@microsoft/clarity'
import React from 'react'
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom'

const dsn = import.meta.env.VITE_SENTRY_DSN

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/aisym-backend.*\.herokuapp\.com/],
    beforeSend: (event) => {
      // Filter out expected 401 redirect errors
      if (
        event.exception?.values?.some(
          (e) => e.value?.includes('401') || e.value?.includes('Unauthorized')
        )
      ) {
        return null
      }
      return event
    },
  })
}

// Microsoft Clarity — product analytics (heatmaps, session recordings)
if (import.meta.env.PROD) {
  Clarity.init('vnoovukc5a')
}

// Google Analytics 4 — loaded via index.html (standard gtag snippet)
